// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import Router, { useRouter } from 'next/router';
import LegacyManageFormDefinition from '@/components/form-definition/manage';
import * as Enums from '@/utils/enums';
import Fetch from '@/utils/Fetch';
import { useQuery } from '@tanstack/react-query';
import BillingService from '@/services/billing-service';
import Helper from '@/utils/helper';
import SubscriptionContext from '@/utils/subscription-context';
import SettingsMenu from '@/components/settings/menu';
import ManageFormDefinition from "@/PageComponents/Settings/ManageFormDefinition";
import { createFileRoute } from '@tanstack/react-router'

const EditFormDefinition = () => {

  const router = useRouter();
  const { id } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

  let currPath = '';
  if (Router.router) {
    currPath = Router.router.asPath;
  }

  const subscriptionContext = useContext(SubscriptionContext);
  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

  const getAccessStatus = async () => {
    const [subscriptionInfo, message] = await BillingService.getSubcriptionInfo(subscriptionContext);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  // const [formDefinition, setFormDefinition] = useState(formDefinition);

  useEffect(() => {
    getAccessStatus();
  }, []);
  
  const { data: formDefinition } = useQuery(
    ['formDefinition', id],
    () => Fetch.get({ url: `/FormDefinition/${id}` }),
    { enabled: !!id }
  );
  
  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace,"/");
    }
  }, [accessStatus]);
  if (!formDefinition) return null;

  return (
    <div className="settings-container">
      {/*<div className="row">
        <div className="title">
          <Breadcrumbs
            crumbs={[
              { text: 'Settings', link: '', suppressLink: true },
              { text: 'Forms', link: '/settings/form/list' },
              { text: `${formDefinition.Name}`, link: '' },
            ]}
          />
        </div>
      </div>*/}
      
      <div className="row">
        <SettingsMenu urlPath={currPath} />
        <div className="settings-card">

          <ManageFormDefinition formDefinition={formDefinition} isNew={false} accessStatus={accessStatus} />

          {/*<LegacyManageFormDefinition formDefinition={formDefinition} setFormDefinition={setFormDefinition} isNew={false} accessStatus={accessStatus} />*/}
        </div>
      </div>
      
      <style jsx>{`
        .row {
          display: flex;
        }
        .column {
          display: flex;
          flex-basis: 0;
          flex-direction: column;
          flex-grow: 1;
        }
        .column :global(.textarea-container) {
          height: 100%;
        }
        .column + .column {
          margin-left: 1.25rem;
        }
      `}</style>
    </div>
  );
};

export default EditFormDefinition;

export const Route = createFileRoute('/_authenticated/settings/form/$id')({ component: EditFormDefinition })
